"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var lodash_1 = require("lodash");
var listing_1 = require("./listing");
var map_ajax_to_props_1 = require("../map_ajax_to_props");
var api_request_1 = require("../api_request");
var listing_row_1 = require("./listing_row");
var user_store_1 = require("../../reverb-js-common/user_store");
var build_search_params_1 = require("./build_search_params");
var constants_1 = require("../shared/constants");
var url_helpers_1 = require("../shared/url_helpers");
var NON_PARTICIPATING_COUNTRIES = ['US', constants_1.default.EVERYWHERE_CODE];
var NUM_LISTINGS = 12;
function countryOptedOut(countryCode) {
    // "Everywhere" region (XX) does not have country code
    if (!countryCode) {
        return true;
    }
    return !!(NON_PARTICIPATING_COUNTRIES.indexOf(countryCode) + 1);
}
var RegionalListings = /** @class */ (function (_super) {
    tslib_1.__extends(RegionalListings, _super);
    function RegionalListings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RegionalListings, "defaultProps", {
        get: function () {
            return {
                countryCode: user_store_1.default.getState().countryCode,
                minimumListings: 4,
                error: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegionalListings.prototype, "marketplaceHref", {
        get: function () {
            return "/marketplace?item_region=" + this.props.countryCode;
        },
        enumerable: true,
        configurable: true
    });
    RegionalListings.prototype.renderHeader = function () {
        var iconClassName = 'flag-icon-header__icon ' +
            ("flag-icon flag-icon-" + this.props.countryCode.toLowerCase());
        return (React.createElement("div", { className: "flag-icon-header" },
            React.createElement("span", { className: iconClassName }),
            I18n.t('discovery.regionalListings.title', {
                country: I18n.t("countries." + this.props.countryCode)
            })));
    };
    RegionalListings.prototype.render = function () {
        if (this.props.error) {
            return null;
        }
        if (countryOptedOut(user_store_1.default.getState().countryCode)) {
            return null;
        }
        return (React.createElement("div", { className: "homepage-container__component-wrapper homepage-container__component-wrapper--thin" },
            React.createElement(listing_row_1.default, { listings: this.props.listings, expectedCount: NUM_LISTINGS, trackName: "regionalListings", titleElement: this.renderHeader(), ctaText: I18n.t('discovery.regionalListings.viewMore'), ctaTarget: this.marketplaceHref, minListings: this.props.minimumListings, alwaysShowCTA: true, largeTiles: true })));
    };
    return RegionalListings;
}(React.Component));
function buildParams(params) {
    if (params === void 0) { params = {}; }
    return build_search_params_1.default(tslib_1.__assign(tslib_1.__assign({}, params), { item_region: user_store_1.default.getState().countryCode, condition: constants_1.default.USED_CONDITION }));
}
function fetcher(props) {
    return new Promise(function (resolve) {
        if (countryOptedOut(user_store_1.default.getState().countryCode)) {
            resolve({});
        }
        else {
            var req = api_request_1.default.V3.get(url_helpers_1.default.listingsGridPath(), buildParams(props.params));
            req.then(function (data) {
                var resp = data;
                var randomizedListings = lodash_1.shuffle(resp.listings).slice(0, NUM_LISTINGS);
                var randomizedListingModels = randomizedListings.map(function (listing) { return new listing_1.default(listing); });
                resolve({
                    total: data.total,
                    listings: randomizedListingModels,
                });
            }).fail(function () {
                resolve({ error: true });
            });
        }
    });
}
exports.default = map_ajax_to_props_1.default(fetcher)(RegionalListings, 'RegionalListings');
//# sourceMappingURL=regional_listings.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/regional_listings.js
// module id = oOrz
// module chunks = 20 21